import { useState } from 'react';

import { useAtom } from 'jotai';

import { updateStaffTransportReservations } from '@/api/updateStaffTransportReservations';
import Button from '@/components/Button/Button';
import { LineUserAtom } from '@/jotai/jotai';
import { StaffTransportReservation } from '@/types/pickupDropoff';

type Props = {
  officeID: string | undefined;
  reservations: StaffTransportReservation[];
  refreshReservations: () => Promise<void>; // 最新データを取得する関数を受け取る
};

const BoardingInfo = ({ officeID, reservations, refreshReservations }: Props) => {
  const [lineUser, _] = useAtom(LineUserAtom);
  const [updating, setUpdating] = useState<{ [key: number]: boolean }>({});

  const handleBoarding = async (reservationId: number) => {
    setUpdating((prev) => ({ ...prev, [reservationId]: true }));

    try {
      const result = await updateStaffTransportReservations(
        lineUser?.lineID ?? '',
        lineUser?.accessToken ?? '',
        officeID ?? '',
        {
          reservation_id: reservationId,
          is_boarding: true,
          is_get_off: false,
        }
      );
      if (result.status === 200) {
        console.log('乗車時刻が更新されました:', result.result);
        await refreshReservations(); // 最新データを取得
      } else {
        console.error('乗車時刻の更新に失敗しました');
      }
    } catch (error) {
      console.error('APIエラー:', error);
    }

    setUpdating((prev) => ({ ...prev, [reservationId]: false }));
  };

  return (
    <div className="space-y-6 p-4">
      {reservations.length > 0 ? (
        reservations.map((reservation) => (
          <div
            key={reservation.id}
            className="rounded-md p-4"
          >
            <div className="space-y-6">
              <div className="text-base font-bold leading-relaxed">利用者（児童名）</div>
              <div className="text-base leading-relaxed">{reservation.child_name}</div>

              <hr className="border-gray-400" />

              <div className="space-y-6">
                <div className="text-base font-bold leading-relaxed">時刻</div>
                <div className="text-base leading-relaxed">
                  {reservation.pickup_transport_info?.time?.slice(0, 5) || '-'}
                </div>
                <hr className="border-gray-400" />
              </div>

              <div className="space-y-6">
                <div className="text-base font-bold leading-relaxed">送迎場所</div>
                <div className="text-base leading-relaxed">
                  {reservation.pickup_transport_info?.location || '-'}
                </div>
                <hr className="border-gray-400" />
              </div>

              <div className="text-base font-bold leading-relaxed">送迎（来所）時刻</div>
              <div className="flex items-center justify-between">
                <div className="w-full text-base leading-relaxed">
                  {reservation.pickup_transport_info?.boarding_time ? (
                    reservation.pickup_transport_info.boarding_time.slice(0, 5)
                  ) : (
                    <Button
                      type="button"
                      size="fl"
                      variant="outline"
                      onClick={() => handleBoarding(reservation.id)}
                      disabled={updating[reservation.id]}
                    >
                      {updating[reservation.id] ? '更新中...' : '乗車'}
                    </Button>
                  )}
                </div>
              </div>
              <hr className="border-gray-400" />
            </div>
          </div>
        ))
      ) : (
        <div className="p-4 text-gray-500">本日の予約はありません。</div>
      )}
    </div>
  );
};

export default BoardingInfo;
